// component
import SvgColor from '../../../components/svg-color';

// ----------------------------------------------------------------------

const icon = (name, other, w = 22, h = 22) =>
  other ? (
    <img
      alt="navIcon"
      src={`${process.env.PUBLIC_URL}/assets/icons/navbar/${name}.${other}`}
      style={{ width: w, height: h }}
    />
  ) : (
    <SvgColor src={`${process.env.PUBLIC_URL}/assets/icons/navbar/${name}.svg`} sx={{ width: 1, height: 1 }} />
  );

const MastersData = [ 
  {
    title: 'User',
    path: '/dashboard/masters/user',
    icon: icon('user'),
    ShortName: 'Masters_User',
  },
  {
    title: 'Division',
    path: '/dashboard/masters/division',
    icon: icon('division', 'png', 32, 32),
    ShortName: 'Masters_Division',
  },
  {
    title: 'Country',
    path: '/dashboard/masters/country',
    icon: icon('country', 'png'),
    ShortName: 'Masters_Country',
  }, 
];

export default MastersData;
